<template>
  <div class="flex items-center">
    <div style="height: 60px; width: 60px;">
      <img :src="image" :height="height"/>
    </div>
  </div>
</template>

<script>
  import router from '@/router'
  export default {
    name: 'CRImage',
    computed: {
      image() {
        const imageURL = [this.$data.data.column.imagesURL, '/', this.imageSource, '%2F', this.imageID, '@', this.$data.data.column.imageHeight, '.png?alt=media'].join('');
        return imageURL;
      },
      imageSource() {
        if (this.$data.data.column.imageSource) {
          return this.$data.data.column.imageSource;
        } else {
          return 'products';
        }
      },
      imageID() {
        if (this.$data.data.column.imageID) {
          return this.$data.data.imageURL.split('.')[0];
        } else {
          return this.$data.data.id;
        }
      },
      height() {
        return parseInt(this.$data.data.column.imageHeight);
      },
      altImage() {
        return this.$data.data[this.$data.data.column.altImage];
      },
      routeName() {
        return `${this.$data.data.column.routeName}`
      }
    },
    methods: {
      route() {
        // router.push({path: this.url, params: {id: this.$data.data.id}})
        router.push({name: this.routeName, params: {id: this.$data.data.id}})
      }
    }
  }
</script>
